var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Vue } from 'vue-property-decorator';
import * as yup from 'yup';
var ParkingValidationMixin = /** @class */ (function (_super) {
    __extends(ParkingValidationMixin, _super);
    function ParkingValidationMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ParkingValidationMixin.prototype, "step1ValidationSchema", {
        get: function () {
            var _a;
            var t = ((_a = this.translations) === null || _a === void 0 ? void 0 : _a.step1) || {};
            return yup.object().shape({
                engineVolume: yup
                    .string()
                    .required(t.engine_volume_required || 'Mühərrik həcmi tələb olunur'),
                averagePrice: yup
                    .string()
                    .required(t.average_price_required || 'Orta qiymət tələb olunur'),
                releaseYear: yup
                    .string()
                    .required(t.release_year_required || 'Buraxılış ili tələb olunur'),
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParkingValidationMixin.prototype, "step2ValidationSchema", {
        get: function () {
            var _a;
            var t = ((_a = this.translations) === null || _a === void 0 ? void 0 : _a.step1) || {};
            return yup.object().shape({
                registrationPlate: yup
                    .string()
                    .required(t.registration_plate_required || 'Qeydiyyat nişanı tələb olunur'),
                banNumber: yup
                    .string()
                    .required(t.ban_number_required || 'Ban nömrəsi tələb olunur'),
                brand: yup
                    .string()
                    .required(t.brand_required || 'Marka seçilməlidir'),
                model: yup
                    .string()
                    .required(t.model_required || 'Model seçilməlidir'),
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParkingValidationMixin.prototype, "step3ValidationSchema", {
        get: function () {
            var _a;
            var t = ((_a = this.translations) === null || _a === void 0 ? void 0 : _a.step2) || {};
            return yup.object().shape({
                fin: yup
                    .string()
                    .required(t.fin_required || 'FIN kod tələb olunur')
                    .length(7, t.fin_invalid || 'FIN kod 7 simvoldan ibarət olmalıdır'),
                phone: yup
                    .string()
                    .required(t.phone_required || 'Telefon nömrəsi tələb olunur')
                    .test('phone-format', t.phone_invalid || 'Telefon nömrəsi düzgün formatda deyil', function (value) {
                    if (!value)
                        return true;
                    var digits = value.replace(/\D/g, '');
                    if (digits.length !== 12) {
                        return this.createError({
                            message: t.phone_invalid || 'Telefon nömrəsi tam daxil edilməlidir'
                        });
                    }
                    var operatorCode = digits.substring(3, 5);
                    var allowedCodes = ['10', '50', '51', '55', '70', '77', '99'];
                    if (!allowedCodes.includes(operatorCode)) {
                        return this.createError({
                            message: t.phone_operator_invalid || 'Operator kodu düzgün deyil (10, 50, 51, 55, 70, 77, 99)'
                        });
                    }
                    return true;
                }),
                firstName: yup
                    .string()
                    .required(t.first_name_required || 'Ad tələb olunur')
                    .matches(/^[A-Za-zƏəİıÖöÜüĞğŞşÇç\s]+$/, t.first_name_invalid || 'Ad yalnız hərflərdən ibarət olmalıdır')
                    .max(30, t.first_name_max || 'Ad maksimum 30 simvol ola bilər'),
                lastName: yup
                    .string()
                    .required(t.last_name_required || 'Soyad tələb olunur')
                    .matches(/^[A-Za-zƏəİıÖöÜüĞğŞşÇç\s]+$/, t.last_name_invalid || 'Soyad yalnız hərflərdən ibarət olmalıdır')
                    .max(30, t.last_name_max || 'Soyad maksimum 30 simvol ola bilər'),
                fatherName: yup
                    .string()
                    .required(t.father_name_required || 'Ata adı tələb olunur')
                    .matches(/^[A-Za-zƏəİıÖöÜüĞğŞşÇç\s]+$/, t.father_name_invalid || 'Ata adı yalnız hərflərdən ibarət olmalıdır')
                    .max(30, t.father_name_max || 'Ata adı maksimum 30 simvol ola bilər'),
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParkingValidationMixin.prototype, "step4ValidationSchema", {
        get: function () {
            var _a;
            var t = ((_a = this.translations) === null || _a === void 0 ? void 0 : _a.step3) || {};
            return yup.object().shape({
                company: yup
                    .string()
                    .required(t.company_required || 'Sığorta şirkəti seçilməlidir'),
            });
        },
        enumerable: false,
        configurable: true
    });
    ParkingValidationMixin.prototype.validateStep1 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var step1Valid, step2Valid, err_1, errors_1, err_2, errors_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        step1Valid = true;
                        step2Valid = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.step1ValidationSchema.validate(this.stepsData.step1, { abortEarly: false })];
                    case 2:
                        _a.sent();
                        this.step1Errors = {};
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        errors_1 = {};
                        if (err_1.inner) {
                            err_1.inner.forEach(function (error) {
                                errors_1[error.path] = error.message;
                            });
                        }
                        this.step1Errors = errors_1;
                        step1Valid = false;
                        return [3 /*break*/, 4];
                    case 4:
                        _a.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, this.step2ValidationSchema.validate(this.stepsData.step2, { abortEarly: false })];
                    case 5:
                        _a.sent();
                        this.step2Errors = {};
                        return [3 /*break*/, 7];
                    case 6:
                        err_2 = _a.sent();
                        errors_2 = {};
                        if (err_2.inner) {
                            err_2.inner.forEach(function (error) {
                                errors_2[error.path] = error.message;
                            });
                        }
                        this.step2Errors = errors_2;
                        step2Valid = false;
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/, step1Valid && step2Valid];
                }
            });
        });
    };
    ParkingValidationMixin.prototype.validateStep2 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_3, errors_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.step2ValidationSchema.validate(this.stepsData.step2, { abortEarly: false })];
                    case 1:
                        _a.sent();
                        this.step2Errors = {};
                        return [2 /*return*/, true];
                    case 2:
                        err_3 = _a.sent();
                        errors_3 = {};
                        if (err_3.inner) {
                            err_3.inner.forEach(function (error) {
                                errors_3[error.path] = error.message;
                            });
                        }
                        this.step2Errors = errors_3;
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ParkingValidationMixin.prototype.validateStep3 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_4, errors_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.step3ValidationSchema.validate(this.stepsData.step3, { abortEarly: false })];
                    case 1:
                        _a.sent();
                        this.step3Errors = {};
                        return [2 /*return*/, true];
                    case 2:
                        err_4 = _a.sent();
                        errors_4 = {};
                        if (err_4.inner) {
                            err_4.inner.forEach(function (error) {
                                errors_4[error.path] = error.message;
                            });
                        }
                        this.step3Errors = errors_4;
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ParkingValidationMixin.prototype.validateStep4 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_5, errors_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.step4ValidationSchema.validate(this.stepsData.step4, { abortEarly: false })];
                    case 1:
                        _a.sent();
                        this.step4Errors = {};
                        return [2 /*return*/, true];
                    case 2:
                        err_5 = _a.sent();
                        errors_5 = {};
                        if (err_5.inner) {
                            err_5.inner.forEach(function (error) {
                                errors_5[error.path] = error.message;
                            });
                        }
                        this.step4Errors = errors_5;
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ParkingValidationMixin.prototype.validateCurrentStep = function (currentStep) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(currentStep === 1)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.validateStep1()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        if (!(currentStep === 2)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.validateStep3()];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        if (!(currentStep === 3)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.validateStep4()];
                    case 5: return [2 /*return*/, _a.sent()];
                    case 6: return [2 /*return*/, true];
                }
            });
        });
    };
    ParkingValidationMixin = __decorate([
        Component
    ], ParkingValidationMixin);
    return ParkingValidationMixin;
}(Vue));
export default ParkingValidationMixin;
